import { Outlet, createRoute } from '@tanstack/react-router'

import { AreaSidebar, ProductGuard, ProductLayout } from '@/app/routes/area-layout'

import { adminRoute } from './admin-route'

export function SettingsLayout() {
  return (
    <ProductGuard product="admin">
      <ProductLayout sidebar={<AreaSidebar area="admin" />}>
        <Outlet />
      </ProductLayout>
    </ProductGuard>
  )
}

export const settingsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'settings',
  component: SettingsLayout,
})
